/**
* Pain Quiz CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Pain Quiz CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'pain-quiz-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.pain-quiz-cta__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          direction: 'ttb',
          pagination: false,
          autoHeight: true,
          drag: false,
          gap: '32px',
          arrows: false,
          height: '100%',
          autoScroll: {
            pauseOnHover: false,
            speed: 1,
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'pain-quiz-cta', COMPONENT );
} )( app );
